import Vue from 'vue'
import Vuex from 'vuex'
import { actions } from './store/actions'
import { mutations } from './store/mutations'
import unitTypes from './store/modules/unitTypes/unitTypes'
import company from './store/modules/company/company'
import users from './store/modules/users/users'
import tests from './store/modules/tests/tests'
import sites from './store/modules/sites/sites'
import wizard from './store/modules/wizard/wizard'
import units from './store/modules/units/units'
import reports from './store/modules/reports/reports'
import subscriptions from './store/modules/subscriptions/subscriptions'
import permissions from './store/modules/permissions/permissions'
import inspections from './store/modules/inspections/inspections'
import notifications from './store/modules/notifications/notifications'
import incidents from './store/modules/incidents/incidents'
import monitoring from './store/modules/monitoring/monitoring'

Vue.use(Vuex)

export const userState = JSON.parse(localStorage.getItem('token'))
export const loginState = userState === null
export const userLogged = {}
export const notificationsState = null

const state = {
  userState,
  loginState,
  userLogged,
  notificationsState
}

export default new Vuex.Store({
  modules: {
    unitTypes,
    company,
    users,
    tests,
    sites,
    wizard,
    units,
    reports,
    subscriptions,
    permissions,
    inspections,
    notifications,
    incidents,
    monitoring
  },
  state,
  mutations,
  actions
})
